(function () {
    $('#loyalty-filter')
        .find('select')
        .change(function (e) {
            $(this).closest('form').submit();
        });
})();



// WEBPACK FOOTER //
// ./resources/scripts/portal/pages/loyalty/list.js